import { render, staticRenderFns } from "./Exit.vue?vue&type=template&id=477b270f&"
import script from "./Exit.vue?vue&type=script&lang=ts&"
export * from "./Exit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports